import styled, { css } from "styled-components";

interface ButtonWrapperProps {
  readonly hasCancelButton?: boolean;
}

export const StyledButtonWrapper = styled.div<ButtonWrapperProps>`
  display: flex;
  justify-content: center;
  > button {
    margin-inline: 8px;
  }
`;
